// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2Wc1c0","vatWrapper":"_3oXpq_","vat":"_2Fdaoc","vatInput":"_3nb1fx","vatCalculated":"_37jO5N","symbol":"_2g94D9","price":"xlscKa"};